<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="单位资信信息变更申请" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(2)">导入</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="申请表编号">
                                            <a-input ref="bgsqbbh" v-model="editData.bgsqbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="变更日期" required>
                                            <a-date-picker ref="bgrq" v-model="editData.bgrq" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位编号">
                                            <a-input ref="dwbh" v-model="editData.dwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位名称">
                                            <a-input ref="dwmc" v-model="editData.dwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位类型">
                                            <a-input ref="dwlx" v-model="editData.dwlx" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位类别">
                                            <a-input ref="dwlb" v-model="editData.dwlb" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="资信等级">
                                            <a-input ref="zxdj" v-model="editData.zxdj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入时间">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                                            <a-textarea v-model="editData.bz" :rows="3" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 资信等级明细表格 -->
                        <FGCollapsiblePanel title="资信等级">
                            <vxe-toolbar size="mini">
                                <template v-slot:tools>
                                    <a-button type="primary" :loading="saving || loading" @click="insertZxdjItem">新增</a-button>
                                </template>
                            </vxe-toolbar>
                            <vxe-table
                                ref="ZXDJitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataZXDJ"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.xh" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zxdj"
                                    title="资信等级"
                                    width="130"
                                    header-class-name="required"
                                    sortable
                                    ><template v-slot:edit="scope"> <FGDictSelectCN ref="zxdj" dictNo="ZX100102" v-model="scope.row.zxdj" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zxlb"
                                    title="资信类别"
                                    width="130"
                                    header-class-name="required"
                                    sortable
                                    ><template v-slot:edit="scope"> <FGDictSelectCN ref="zxlb" dictNo="ZX100103" v-model="scope.row.zxlb" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zslb"
                                    title="证书类别"
                                    width="130"
                                    header-class-name="required"
                                    sortable
                                    ><template v-slot:edit="scope"> <FGDictSelectCN ref="zslb" dictNo="ZX100105" v-model="scope.row.zslb" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zsbh"
                                    title="证书编号"
                                    width="150"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.zsbh" /> </template
                                ></vxe-table-column>
                                <FGDataSelect :isShow.sync="isShow_zsmc" selectNo="JC1013" @saveselect="saveEvent_zsmc(arguments, editItemData)"></FGDataSelect>
                                <vxe-table-column field="zsmc" title="证书名称" width="150" :edit-render="{ type: 'default', autofocus: 'input' }">
                                    <template v-slot:edit="scope">
                                        <a-input-search size="small" ref="zsmc" readOnly @search="search_zsmc(scope.row)" v-model="scope.row.zsmc" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zsrq"
                                    title="证书日期"
                                    width="120"
                                    align="center"
                                >
                                    <template v-slot:edit="scope">
                                        <a-date-picker
                                            ref="zsrq"
                                            v-model="scope.row.zsrq"
                                            width="100%"
                                            valueFormat="YYYY-MM-DD"
                                            style="width:100%"
                                            @change="zsdqrqChangeEvent(scope.row)"
                                        />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zzyxq" title="资质有效期(年)" width="105" align="right">
                                    <template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.zzyxq" /> </template>
                                </vxe-table-column>
                                <vxe-table-column field="zsdqrq" title="证书到期日期" width="100" align="center">
                                    <template v-slot:edit="scope">
                                        <a-date-picker ref="zsdqrq" v-model="scope.row.zsdqrq" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="bz"
                                    title="备注"
                                    width="200"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.bz" /> </template
                                ></vxe-table-column>
                                <vxe-table-column title="操作" align="center" width="160">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="removeZxdjItem(scope.row)">删除</span>
                                        <span class="btn_edit" @click="zyxxInsert(scope.row)">专业信息</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                    </a-spin>
                    <!-- 操作日志 -->
                    <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload :isnew="editData.isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
        <ZyxxEdit :showMxEdit.sync="editProps.showMxEdit" :dataId="editProps.dataId" :zxdjbgid="editProps.zxdjbgid" />
    </div>
</template>
<script>
import ZyxxEdit from "./ZyxxEdit";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "DwzxbgsqEdit",
    components: { ZyxxEdit },
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            isShow1: false,
            isShow2: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            editItemDataZXDJ: [],
            editItemDataZXDJLoading: false,

            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            },
            isShow_zsmc: false,
            isShow_zymc: false,
            editProps: {
                showMxEdit: false,
                dataId: null,
                zxdjbgid: ""
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                visible: false,
                fktable: "DW_BGSQB",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "DW5005"
            };
        }
    },
    activated() {
        if (!this.editDataId) {
            this.$FG_http
                .post(
                    "./api/main/zxdw/dwzxbg/selectByUser",
                    {
                        yhid: this.getUserInfo.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 新增，设置默认值
                            this.editData = {
                                id: this.$FG_util.uuid(),
                                isnew: true,
                                djlxid: "ZXBGSQB",
                                bglx: "资信等级变更",
                                bgsqbbh: "",
                                bgrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                                dwid: data.data.id,
                                dwbh: data.data.dwbh,
                                dwmc: data.data.dwmc,
                                dwlx: data.data.dwlx,
                                dwlb: data.data.dwlb,
                                dwxz: data.data.dwxz,
                                zxdj: data.data.zxdj,
                                qyid: data.data.qyid,
                                bmid: this.getUserInfo.org_id,
                                yhid: this.getUserInfo.id,
                                ryid: this.getUserInfo.personnel_id,
                                lrbmmc: this.getUserInfo.org_name,
                                lrrxm: this.getUserInfo.personnel_name,
                                lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                                djzt: "制定"
                            };
                            this.$FG_helper.handleNewBillCode("ZXBGSQ").then((val) => {
                                this.editData.bgsqbbh = val;
                            });
                            this.editItemDataZXDJ = [];
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        } else {
            // 修改，加载数据
            this.loadData();
        }
    },
    methods: {
        search_zsmc(row) {
            row.zsmc = null;
            this.isShow_zsmc = true;
            this.select_zsmc = row;
        },
        saveEvent_zsmc(val, row) {
            if (val && val.length > 0) {
                this.select_zsmc.zsmc = val[0][0].ZSMC;
            }
        },
        search_zymc(row) {
            this.isShow_zymc = true;
            this.select_zymc = row;
        },
        saveEvent_zymc(val, row) {
            if (val && val.length > 0) {
                this.select_zymc.zyid = val[0][0].ID;
                this.select_zymc.zymc = val[0][0].ZYYWLY;
                this.select_zymc.zxlb = val[0][0].ZXLB;
            }
        },
        zsdqrqChangeEvent(row) {
            this.selCYMXRow = row;
            if (row.zsrq === null) {
                this.selCYMXRow.zsdqrq = null;
            } else {
                this.selCYMXRow.zsdqrq = parseInt(row.zsrq.substring(0, 4)) + row.zzyxq + row.zsrq.substring(4, row.zsrq.length);
            }
        },
        saveEvent(val) {
            if (val && val.length > 0) {
                this.editData.qybh = val[0][0].QYBH;
                this.editData.qymc = val[0][0].QYMC;
                this.editData.qyid = val[0][0].ID;
            }
        },
        saveEvent1(val) {
            if (val && val.length > 0) {
                this.editData.hyfl = val[0][0].ZYMC;
            }
        },
        // 专业信息明细
        zyxxInsert(row) {
            //验证保存主表信息
            if (this.editData.isnew) {
                this.$FG_message.error("请先保存主表信息！");
                return;
            }
            // 设置编辑记录id
            this.editProps.dataId = this.editData.id;
            this.editProps.zxdjbgid = row.id;
            // 显示编辑窗口
            this.editProps.showMxEdit = true;
        },
        confirm() {
            this.editData.qrrxm = this.getUserInfo.personnel_name;
            this.$FG_http
                .post("./api/main/zxdw/dwzxbg/confirm", {
                    id: this.editData.id,
                    qrrid: this.getUserInfo.id
                })
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        // 返回列表
                        this.onBack();
                    } else {
                        this.$refs.bgrq.focus();
                    }
                });
        },
        unConfirm() {
            this.$FG_http
                .post("./api/main/zxdw/dwzxbg/unConfirm", {
                    id: this.editData.id
                })
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        // 返回列表
                        this.onBack();
                    } else {
                        this.$refs.bgrq.focus();
                    }
                });
        },
        //提交form
        onSave(btnType) {
            // 获取全部数据
            let ZXDJitemData = this.$refs.ZXDJitemTable.getTableData().tableData;
            if (btnType === 1) {
                if (!this.editData.bgrq) {
                    this.$FG_message.error("P0001", "变更日期").then(() => this.$refs.bgrq.focus());
                    return;
                }

                for (let i = 0; i < ZXDJitemData.length; i++) {
                    if (!ZXDJitemData[i].zxdj) {
                        this.$FG_message.error("P0001", "资信等级").then(() => {
                            this.$refs.ZXDJitemTable.setActiveRow(ZXDJitemData[i]);
                        });
                        return;
                    }
                    if (!ZXDJitemData[i].zxlb) {
                        this.$FG_message.error("P0001", "资信类别").then(() => {
                            this.$refs.ZXDJitemTable.setActiveRow(ZXDJitemData[i]);
                        });
                        return;
                    }
                    if (!ZXDJitemData[i].zslb) {
                        this.$FG_message.error("P0001", "证书类别").then(() => {
                            this.$refs.ZXDJitemTable.setActiveRow(ZXDJitemData[i]);
                        });
                        return;
                    }
                }
            }

            // 保存操作
            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/dwzxbg/save",
                    {
                        data: this.editData,
                        ZXDJitemData
                    },
                    {
                        showSuccess: btnType !== 0 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                    } else {
                        this.$refs.bgrq.focus();
                    }
                })
                .then(() => {
                    if (this.editDataId) {
                        if (btnType === 1) {
                            this.submit();
                        } else if (btnType === 2) {
                            this.importData();
                        } else {
                            this.loadData();
                        }
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/zxdw/dwzxbg/submit", {
                            id: this.editData.id
                            //,tjrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss")
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.bgrq.focus();
                            }
                        });
                }
            });
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/dwzxbg/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            // 加载明细数据
                            this.loadItemDataZXDJ();
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.insertIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.insertIsVisible = false;
                    }
                });
        },
        // 加载明细表数据
        loadItemDataZXDJ() {
            this.editItemDataZXDJ = [];
            this.editItemDataZXDJLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/dwzxbg/listItemZXDJ",
                    {
                        bgsqbid: this.editDataId,
                        sort: {
                            field: "zsbh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataZXDJLoading = false;
                    if (success) {
                        this.editItemDataZXDJ = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        importData() {
            this.$FG_message.confirm("DR100101", "资信等级及专业").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/zxdw/dwzxbg/importData", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 重新加载数据
                                this.loadData();
                            } else {
                                this.$refs.bgrq.focus();
                            }
                        });
                }
            });
        },
        insertZxdjItem() {
            // 设置编辑记录
            let xh = this.$refs.ZXDJitemTable.getInsertRecords().concat(this.$refs.ZXDJitemTable.getUpdateRecords()).length + 1;
            this.$refs.ZXDJitemTable.insertAt(
                {
                    isnew: true,
                    id: this.$FG_util.uuid(),
                    bgsqbid: this.editData.id,
                    zzyxq: 5,
                    xh: xh,
                    ydjbj: 0
                },
                -1
            ).then(({ row }) => {
                this.$refs.ZXDJitemTable.setActiveRow(row);
            });
        },
        // 删除明细
        removeZxdjItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.ZXDJitemTable.remove(row);
                    } else {
                        this.editItemDataZXDJLoading = true;
                        this.$FG_http
                            .post("./api/main/zxdw/dwzxbg/deleteZxdjMx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.editItemDataZXDJLoading = false;
                                if (success) {
                                    this.loadItemDataZXDJ();
                                }
                            });
                    }
                }
            });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
